import dayjs from "dayjs";
import { SearchFormInputs } from "src/Modules/Hotels/constants";

const prepareSearchObject = (searchObject: SearchFormInputs) => {
  return {
    ...searchObject,
    checkin: searchObject.checkin ? dayjs(searchObject.checkin) : undefined,
    checkout: searchObject.checkout ? dayjs(searchObject.checkout) : undefined,
  };
};

export { prepareSearchObject };
